/** Get the upper public domain based on the current environment */
const getUpperDomain = () => {
  if (import.meta.env.VITE_ENV === 'production') {
    return '.kimbi.cz';
  }
  if (
    import.meta.env.VITE_ENV === 'test' ||
    import.meta.env.VITE_ENV === 'stage'
  ) {
    return '.4finance.com';
  }
  return 'localhost';
};

export default getUpperDomain;
